import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html'
})
export class EditComponent {
  @Input() ariaLabel: string = '';
}
